<template>
  <div
    class="cache-container"
    ref="header"
    :class="
      (options.type === 'header' ? 'page-header-container' : '', options.type && headerFixedStatu ? 'fixed-header' : '')
    "
  >
    <div v-if="options.type === 'header'" class="handle-btn-groups">
      <a v-if="options.setLink" :href="options.setLink" target="_blank" class="handle-icon-box">
        <i class="icon icon-portal-card-view"></i>
        <span class="icon-tips">设置</span>
      </a>
      <a class="handle-icon-box" @click="changeHeaderFixedStatu">
        <i class="icon" :class="headerIsFixed ? 'icon-portal-pined' : 'icon-portal-pin'"></i>
        <span class="icon-tips">固定头部</span>
      </a>
    </div>
    <div v-html="options.html"></div>
  </div>
</template>

<script>
import eventMixin from "utils/event/eventMixin.js"
export default {
  mixins: [eventMixin],
  name: "cache-component",
  props: {
    options: {
      type: Object,
      default: null
    },
    myid: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      headerFixedStatu: false
    }
  },
  computed: {
    headerIsFixed: {
      get() {
        let flag = this.$store.state[this.request_prefix].page.headerIsFixed
        if (typeof flag === "undefined") {
          flag = false
          this.$changePageAttribute({ option_name: "headerIsFixed", option_val: flag }, true)
        }
        return flag
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "headerIsFixed", option_val: newVal })
      }
    }
  },
  mounted() {
    window.addEventListener("scroll", this.headerFixedChange)
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.headerFixedChange)
  },
  methods: {
    changeHeaderFixedStatu() {
      this.headerIsFixed = !this.headerIsFixed
    },
    headerFixedChange() {
      let hasHeader = this.$store.state[this.request_prefix].page.hasHeader
      if (this.headerIsFixed && this.options.type === "header" && hasHeader) {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        this.headerFixedStatu = scrollTop > 1 ? true : false
      }
    }
  }
}
</script>

<style scoped>
.page-header-container {
  position: relative;
}
.page-header-container .handle-btn-groups {
  position: absolute;
  top: 0;
  right: 10px;
  z-index: 9999;
}
.fixed-header {
  position: fixed;
  z-index: 9999;
  width: 100%;
}
</style>
